import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

function Descarga() {
  const [planes, setPlanes] = useState([]);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [planInfo, setPlanInfo] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [cantidades, setCantidades] = useState({});
  const [kgs, setKgs] = useState({});
  const [vaciosReales, setVaciosReales] = useState({});
  const [estados, setEstados] = useState({});
  const [observaciones, setObservaciones] = useState({});
  const [fotos, setFotos] = useState({});
  const [alertas, setAlertas] = useState({});
  const [mensaje, setMensaje] = useState('');
  const [horaInicio, setHoraInicio] = useState('');
  const [horaFin, setHoraFin] = useState('');
  const fileInputRefs = useRef({});

  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const esEncargado = usuario?.rol === 'encargado';

  const cargarPlanes = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/descarga/planes', {
        headers: { authorization: token }
      });
      setPlanes(res.data);
    } catch (err) { console.error(err); }
  };

  const cargarPedidos = async (plan_id) => {
    try {
      const res = await axios.get(`https://comprasmercadomodelo.online/api/descarga/planes/${plan_id}/pedidos`, {
        headers: { authorization: token }
      });
      setPedidos(res.data);
      setPlanSeleccionado(plan_id);
      const plan = planes.find(p => p.id === plan_id);
      setPlanInfo(plan);
      if (plan?.hora_inicio_descarga) setHoraInicio(plan.hora_inicio_descarga);
      if (plan?.hora_fin_descarga) setHoraFin(plan.hora_fin_descarga);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { cargarPlanes(); }, []);

  const guardarHoras = async () => {
    try {
      await axios.put(
        `https://comprasmercadomodelo.online/api/descarga/planes/${planSeleccionado}/horas`,
        { hora_inicio_descarga: horaInicio, hora_fin_descarga: horaFin },
        { headers: { authorization: token } }
      );
      setMensaje('✅ Horarios guardados');
    } catch (err) { console.error(err); }
  };

  const registrarDescarga = async (pedidoId, cantidadPedida) => {
    const cantidad = cantidades[pedidoId];
    if (!cantidad && cantidad !== 0) {
      setAlertas({ ...alertas, [pedidoId]: '⚠️ Ingresá una cantidad' });
      return;
    }
    try {
      const formData = new FormData();
      formData.append('cantidad_descargada_real', cantidad);
      formData.append('cantidad_vacios_real', vaciosReales[pedidoId] !== undefined ? vaciosReales[pedidoId] : '');
      formData.append('kg_real', kgs[pedidoId] || 0);
      formData.append('estado_mercaderia_descarga', estados[pedidoId] || '');
      formData.append('observacion_descarga', observaciones[pedidoId] || '');
      if (fotos[pedidoId]) {
        formData.append('foto', fotos[pedidoId]);
      }

      const res = await axios.put(
        `https://comprasmercadomodelo.online/api/descarga/pedidos/${pedidoId}`,
        formData,
        { headers: { authorization: token, 'Content-Type': 'multipart/form-data' } }
      );

      if (res.data.coincide) {
        setAlertas({ ...alertas, [pedidoId]: null });
      } else {
        setAlertas({ ...alertas, [pedidoId]: '⚠️ No coinciden las cantidades, revisá de nuevo' });
      }
      setFotos({ ...fotos, [pedidoId]: null });
      cargarPedidos(planSeleccionado);
    } catch (err) { console.error(err); }
  };

  const cerrarDescarga = async () => {
    if (!window.confirm('¿Cerrar la descarga? Una vez cerrada no podrás editar más.')) return;
    try {
      await axios.put(
        `https://comprasmercadomodelo.online/api/descarga/planes/${planSeleccionado}/cerrar`,
        {},
        { headers: { authorization: token } }
      );
      setMensaje('✅ Descarga cerrada correctamente');
      setPlanSeleccionado(null);
      cargarPlanes();
    } catch (err) {
      setMensaje(`❌ ${err.response?.data?.error || 'Error al cerrar'}`);
    }
  };

  const descargaCerrada = planInfo?.estado === 'descargado';
  const todosDescargados = pedidos.every(p => p.estado === 'descargado');

  const getEstadoLabel = (estado) => {
    const map = {
      verde: { label: '🟢 Verde', color: '#27ae60' },
      punto_medio: { label: '🟡 Punto medio', color: '#f39c12' },
      maduro: { label: '🟠 Maduro', color: '#e67e22' },
      demasiado_maduro: { label: '🔴 Demasiado maduro', color: '#e74c3c' }
    };
    return map[estado] || null;
  };

  if (planSeleccionado) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.botonVolver} onClick={() => setPlanSeleccionado(null)}>← Volver</button>
          <h3 style={styles.titulo}>📦 Descarga de Mercadería</h3>
          {!descargaCerrada ? (
            <button
              style={{ ...styles.botonCerrar, opacity: todosDescargados ? 1 : 0.5 }}
              onClick={cerrarDescarga}
              disabled={!todosDescargados}>
              🔒 Cerrar Descarga
            </button>
          ) : (
            <span style={styles.cerradoBadge}>🔒 Descarga Cerrada</span>
          )}
        </div>

        {mensaje && (
          <div style={styles.mensajeBox}>
            {mensaje}
            <button style={styles.cerrarMensaje} onClick={() => setMensaje('')}>✕</button>
          </div>
        )}

        <div style={styles.horariosBox}>
          <span style={styles.horariosLabel}>⏰ Horario de descarga:</span>
          <div style={styles.horariosInputs}>
            <div style={styles.horarioItem}>
              <label style={styles.label}>Inicio</label>
              <input style={styles.inputHora} type="time" value={horaInicio}
                onChange={(e) => setHoraInicio(e.target.value)}
                disabled={descargaCerrada && !esEncargado} />
            </div>
            <div style={styles.horarioItem}>
              <label style={styles.label}>Fin</label>
              <input style={styles.inputHora} type="time" value={horaFin}
                onChange={(e) => setHoraFin(e.target.value)}
                disabled={descargaCerrada && !esEncargado} />
            </div>
            {(!descargaCerrada || esEncargado) && (
              <button style={styles.botonGuardarHora} onClick={guardarHoras}>💾 Guardar</button>
            )}
          </div>
        </div>

        <div style={styles.resumen}>
          <span style={styles.resumenTexto}>
            ✅ {pedidos.filter(p => p.estado === 'descargado').length} / {pedidos.length} productos descargados
          </span>
        </div>

        <div style={styles.tablaContainer}>
          <table style={styles.tabla}>
            <thead>
              <tr style={styles.thead}>
                <th style={styles.th}>CÓDIGO</th>
                <th style={styles.th}>PRODUCTO</th>
                {esEncargado && <th style={styles.th}>CANT.</th>}
                <th style={styles.th}>VACÍO</th>
                <th style={styles.th}>$ VACÍO</th>
                <th style={styles.th}>VAC. REAL</th>
                <th style={styles.th}>REAL</th>
                <th style={styles.th}>KG/BULTO</th>
                <th style={styles.th}>ESTADO</th>
                <th style={styles.th}>PROVEEDOR</th>
                <th style={styles.th}>OBS. / 📷</th>
                <th style={styles.th}>✓</th>
              </tr>
            </thead>
            <tbody>
              {pedidos.map((p) => {
                const descargado = p.estado === 'descargado';
                const estadoDescarga = getEstadoLabel(p.estado_mercaderia_descarga);

                return (
                  <React.Fragment key={p.id}>
                    <tr style={{ ...styles.tr, backgroundColor: descargado ? '#f0fff4' : 'white' }}>
                      <td style={styles.tdCodigo}>{p.producto_codigo}</td>
                      <td style={styles.tdProducto}>{p.producto_nombre}</td>
                      {esEncargado && <td style={styles.tdCant}>{p.cantidad_pedida}</td>}
                      <td style={styles.td}>{p.vacio_nombre || '-'}</td>
                      <td style={styles.td}>{p.precio_vacio > 0 ? `$${Number(p.precio_vacio).toLocaleString('es-AR')}` : '-'}</td>
                      <td style={styles.td}>{(!descargaCerrada || esEncargado) ? (<input style={styles.inputReal} type="number" placeholder="0" value={vaciosReales[p.id] !== undefined ? vaciosReales[p.id] : (p.cantidad_vacios_real > 0 ? p.cantidad_vacios_real : '')} onChange={(e) => setVaciosReales({ ...vaciosReales, [p.id]: e.target.value })} />) : (<span>{p.cantidad_vacios_real ?? '-'}</span>)}{p.cantidad_vacios != null && Number(vaciosReales[p.id] !== undefined ? vaciosReales[p.id] : p.cantidad_vacios_real) !== Number(p.cantidad_vacios) && (vaciosReales[p.id] !== undefined ? vaciosReales[p.id] !== '' : p.cantidad_vacios_real != null) ? <span style={{color:'red',fontSize:'11px',display:'block'}}>?? pedido: {p.cantidad_vacios}</span> : null}</td>
                      <td style={styles.td}>
                        {(!descargaCerrada || esEncargado) ? (
                          <input style={styles.inputReal} type="number" placeholder="0"
                            value={cantidades[p.id] !== undefined ? cantidades[p.id] : (p.cantidad_descargada_real > 0 ? p.cantidad_descargada_real : '')}
                            onChange={(e) => setCantidades({ ...cantidades, [p.id]: e.target.value })} />
                        ) : (
                          <span style={styles.valorReal}>{p.cantidad_descargada_real || '-'}</span>
                        )}
                      </td>
                      <td style={styles.td}>
                        {(!descargaCerrada || esEncargado) ? (
                          <input style={styles.inputKg} type="number" placeholder="kg"
                            value={kgs[p.id] !== undefined ? kgs[p.id] : (p.kg_real > 0 ? p.kg_real : '')}
                            onChange={(e) => setKgs({ ...kgs, [p.id]: e.target.value })} />
                        ) : (
                          <span>{p.kg_real > 0 ? `${p.kg_real}kg` : '-'}</span>
                        )}
                      </td>
                      <td style={styles.td}>
                        {p.estado_mercaderia ? (
                          (!descargaCerrada || esEncargado) ? (
                            <select style={styles.selectEstado}
                              value={estados[p.id] || p.estado_mercaderia_descarga || ''}
                              onChange={(e) => setEstados({ ...estados, [p.id]: e.target.value })}>
                              <option value="">-- elegir --</option>
                              <option value="verde">🟢 Verde</option>
                              <option value="punto_medio">🟡 Punto medio</option>
                              <option value="maduro">🟠 Maduro</option>
                              <option value="demasiado_maduro">🔴 Demasiado maduro</option>
                            </select>
                          ) : (
                            estadoDescarga ? <span style={{ color: estadoDescarga.color, fontSize: '12px' }}>{estadoDescarga.label}</span> : '-'
                          )
                        ) : '-'}
                      </td>
                      <td style={styles.tdProveedor}>{p.proveedor_nombre}</td>
                      <td style={styles.td}>
                        {(!descargaCerrada || esEncargado) ? (
                          <div style={styles.obsContainer}>
                            <input style={styles.inputObs} type="text" placeholder="Observación..."
                              value={observaciones[p.id] !== undefined ? observaciones[p.id] : (p.observacion_descarga || '')}
                              onChange={(e) => setObservaciones({ ...observaciones, [p.id]: e.target.value })} />
                            <div style={styles.fotoContainer}>
                              <input
                                type="file"
                                accept="image/*"
                                capture="environment"
                                style={{ display: 'none' }}
                                ref={el => fileInputRefs.current[p.id] = el}
                                onChange={(e) => {
                                  if (e.target.files[0]) {
                                    setFotos({ ...fotos, [p.id]: e.target.files[0] });
                                  }
                                }}
                              />
                              <button style={styles.botonFoto}
                                onClick={() => fileInputRefs.current[p.id]?.click()}>
                                📷
                              </button>
                              {fotos[p.id] && (
                                <span style={styles.fotoNombre}>✅ {fotos[p.id].name.substring(0, 10)}...</span>
                              )}
                              {!fotos[p.id] && p.foto_descarga && (
                                <a href={`https://comprasmercadomodelo.online/uploads/${p.foto_descarga}`}
                                  target="_blank" rel="noreferrer" style={styles.verFoto}>
                                  Ver 📷
                                </a>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div>
                            {p.observacion_descarga && <span style={styles.obsResaltada}>⚠️ {p.observacion_descarga}</span>}
                            {p.foto_descarga && (
                              <a href={`https://comprasmercadomodelo.online/uploads/${p.foto_descarga}`}
                                target="_blank" rel="noreferrer" style={styles.verFoto}>
                                Ver foto 📷
                              </a>
                            )}
                          </div>
                        )}
                      </td>
                      <td style={styles.td}>
                        {(!descargaCerrada || esEncargado) ? (
                          <button style={{ ...styles.botonRegistrar, backgroundColor: descargado ? '#27ae60' : '#3498db' }}
                            onClick={() => registrarDescarga(p.id, p.cantidad_pedida)}>✓</button>
                        ) : (
                          descargado ? '✅' : '❌'
                        )}
                      </td>
                    </tr>
                    {alertas[p.id] && (
                      <tr>
                        <td colSpan={esEncargado ? 11 : 10} style={styles.alertaRow}>{alertas[p.id]}</td>
                      </tr>
                    )}
                    {p.observacion_descarga && (
                      <tr>
                        <td colSpan={esEncargado ? 11 : 10} style={styles.obsRow}>
                          📝 {p.proveedor_nombre} — {p.producto_nombre}: {p.observacion_descarga}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>📦 Descarga de Mercadería</h3>
      <p style={styles.subtitulo}>Seleccioná el plan a descargar</p>
      <div style={styles.lista}>
        {planes.length === 0 ? (
          <p style={styles.sinPlanes}>No hay planes listos para descargar</p>
        ) : (
          planes.map((plan) => (
            <div key={plan.id} style={styles.tarjeta} onClick={() => cargarPedidos(plan.id)}>
              <span style={styles.fecha}>📅 {new Date(plan.fecha).toLocaleDateString("es-AR", { timeZone: "UTC" })}</span>
              <span style={styles.comentario}>{plan.comentario || 'Sin comentarios'}</span>
              <span style={{ ...styles.estadoPlan, backgroundColor: plan.estado === 'descargado' ? '#27ae60' : '#9b59b6' }}>
                {plan.estado}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
  titulo: { color: '#2c3e50', fontSize: '22px', margin: 0 },
  subtitulo: { color: '#7f8c8d', marginBottom: '20px' },
  botonVolver: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  botonCerrar: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer' },
  cerradoBadge: { backgroundColor: '#7f8c8d', color: 'white', padding: '10px 20px', borderRadius: '6px', fontSize: '14px' },
  mensajeBox: { backgroundColor: '#ffeaa7', padding: '15px 20px', borderRadius: '8px', marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' },
  cerrarMensaje: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' },
  horariosBox: { backgroundColor: 'white', padding: '15px 20px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' },
  horariosLabel: { fontWeight: 'bold', color: '#2c3e50', fontSize: '14px' },
  horariosInputs: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  horarioItem: { display: 'flex', flexDirection: 'column', gap: '4px' },
  label: { fontSize: '12px', color: '#7f8c8d' },
  inputHora: { padding: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  botonGuardarHora: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  resumen: { backgroundColor: '#eaf2ff', padding: '10px 20px', borderRadius: '8px', marginBottom: '15px' },
  resumenTexto: { fontSize: '14px', color: '#2c3e50' },
  tablaContainer: { backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', overflowX: 'auto' },
  tabla: { width: '100%', borderCollapse: 'collapse', minWidth: '900px' },
  thead: { backgroundColor: '#2c3e50' },
  th: { color: 'white', padding: '10px 12px', textAlign: 'left', fontSize: '12px', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid #ecf0f1' },
  tdCodigo: { padding: '8px 12px', fontSize: '12px', color: '#3498db', fontWeight: 'bold', whiteSpace: 'nowrap' },
  tdProducto: { padding: '8px 12px', fontSize: '13px', color: '#2c3e50', minWidth: '180px' },
  tdCant: { padding: '8px 12px', fontSize: '13px', color: '#2c3e50', fontWeight: 'bold', textAlign: 'center' },
  tdProveedor: { padding: '8px 12px', fontSize: '12px', color: '#7f8c8d', minWidth: '150px' },
  td: { padding: '8px 12px', fontSize: '13px', color: '#2c3e50' },
  inputReal: { width: '60px', padding: '5px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px', textAlign: 'center' },
  inputKg: { width: '60px', padding: '5px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px' },
  obsContainer: { display: 'flex', flexDirection: 'column', gap: '5px' },
  inputObs: { width: '120px', padding: '5px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '12px' },
  fotoContainer: { display: 'flex', alignItems: 'center', gap: '5px' },
  botonFoto: { backgroundColor: '#f0f0f0', border: '1px solid #ddd', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' },
  fotoNombre: { fontSize: '11px', color: '#27ae60' },
  verFoto: { fontSize: '12px', color: '#3498db', textDecoration: 'none' },
  selectEstado: { padding: '4px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '12px' },
  valorReal: { fontWeight: 'bold', color: '#27ae60' },
  obsResaltada: { color: '#e74c3c', fontWeight: 'bold', fontSize: '12px', display: 'block' },
  botonRegistrar: { color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  alertaRow: { backgroundColor: '#ffeaa7', padding: '8px 12px', color: '#e67e22', fontWeight: 'bold', fontSize: '13px' },
  obsRow: { backgroundColor: '#fff3cd', padding: '6px 12px', color: '#856404', fontSize: '12px', fontStyle: 'italic' },
  lista: { display: 'flex', flexDirection: 'column', gap: '15px' },
  sinPlanes: { textAlign: 'center', color: '#95a5a6', padding: '40px' },
  tarjeta: { backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  fecha: { fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' },
  comentario: { color: '#7f8c8d' },
  estadoPlan: { color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '12px' }
};

export default Descarga;
